import React from 'react'
import cx from 'classnames'

import styles from './Small.module.css'

const Small = ({ size = 'regular', className, ...rest }) => {
  return <small className={cx(className, styles[size])} {...rest} />
}

export default Small
